import { CodeTypeE, IBaseGetRequest, IBuyerIdentity, ICampaign, RewardTypeE } from 'primsell-shared-layer/types'

export interface IRedeem {
  id: string
  redeemDate: string
  verifiedAt: string | null
  tx: string
  transactionLink: string
  code: string
  campaign: IRedeemCampaign
  buyerIdentity: IRedeemBuyerIdentity
  poapMintStatus: RedeemCodePoapMintStatusesE | null
}

export interface IRedeemCampaign {
  id: string
  name: string
  contractAddress: string
  tokenId: string
  tokenLink: string
}

export interface IRedeemBuyerIdentity {
  wallet: string | null
  walletLink: string | null
  firstName: string | null
  lastName: string | null
  email: string | null
}

export enum RedeemCodePoapMintStatusesE {
  FAILED = 'failed',
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export type IGetRedeemListFilterProperties =
  | 'allCampaign'
  | 'buyerIdentity.id'
  | 'tx'
  | 'buyer'
  | 'redeemDate'
  | 'campaign.id'
  | 'campaign.name'
  | 'campaign.code'

export type IGetRedeemListSortProperties = 'redeemDate' | 'campaign.id' | 'campaign.name' | 'buyerIdentity.firstName'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IGetRedeemListRequest
  extends IBaseGetRequest<IGetRedeemListFilterProperties, IGetRedeemListSortProperties> {}

export interface IRedeemData {
  id: string
  nftId: string
  code: string | null
  redeemDate: string | null
  transactionId: string | null
  transactionLink: string | null
  campaign: Pick<ICampaign, 'id' | 'name' | 'codeType' | 'contractAddress'> | null
  buyerIdentity: IBuyerIdentity | null
  verifiedAt: string | null
  poapMintStatus: RedeemCodePoapMintStatusesE | null
  reward?: {
    id: string
    name: string
    type: RewardTypeE
  }
  rewardId?: string | null
}

export interface IRedeemReward {
  id: string
  nftId: string | null
  redeemDate: string | null
  transactionId: string | null
  transactionLink: string | null
  verifiedAt: string | null
  poapMintStatus: string | null
  campaign: {
    id: string | null
    name: string | null
    codeType: CodeTypeE
  }
  reward: {
    id: string | null
    name: string | null
    type: RewardTypeE
  }
  buyerIdentity: IBuyerIdentity | null
}

export type IGetRedeemRewardListFilterProperties =
  | 'allReward'
  | 'buyer'
  | 'tx'
  | 'redeemDate'
  | 'buyerIdentity.id'
  | 'reward.id'
  | 'reward.name'
  | 'reward.type'
  | 'reward.tokenId'

export type IGetRedeemRewardListSortProperties = 'redeemDate' | 'buyerIdentity.firstName'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IGetRedeemRewardListRequest
  extends IBaseGetRequest<IGetRedeemRewardListFilterProperties, IGetRedeemRewardListSortProperties> {}
